export const styleValueImportant = (style) => {
  if (!style.includes("!important")) {
    return style + " !important"
  } else {
    return style
  }
}